export type RegisterMode = "solo" | "team";

export type TeamChoice =
  | { kind: "existing"; teamId: number }
  | { kind: "new"; name: string };

export type OnAction = (
  action: () => Promise<unknown>,
  successTitle: string,
  failureTitle: string,
  failureFallback: string,
) => Promise<boolean>;

export const formatName = (m: {
  first_name: string | null;
  last_name: string | null;
}): string =>
  [m.first_name, m.last_name].filter(Boolean).join(" ") || "Unnamed";
